import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';

import Wrapper from 'components/Layout/Wrapper';
import Logo from 'components/Layout/Logo';
import Nav from 'components/Layout/Nav';

import styles from './header.module.scss';

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const { site: { siteMetadata: { title } } } = data;

  return (
    <header className={styles.header}>
      <Wrapper className={styles.wrapper}>
        <Link className={styles.link} activeClassName={styles.linkActive} to="/">
          <Logo className={styles.logo} title={title} />
        </Link>
        <Nav />
      </Wrapper>
    </header>
  );
};

export default Header;
